// extracted by mini-css-extract-plugin
export default {"inProgress":"CaseStatus_inProgress__zNGkJ","discarded":"CaseStatus_discarded__rzhAc","finalized":"CaseStatus_finalized__1+m-t"};